var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    {
      attrs: { name: "modal", mode: "in-out", appear: "" },
      on: {
        beforeEnter: _vm.beforeEnter,
        afterEnter: _vm.afterEnter,
        beforeLeave: _vm.beforeLeave,
        afterLeave: _vm.afterLeave,
      },
    },
    [
      _vm.show
        ? _c("div", { staticClass: "modal is-active" }, [
            _c("div", {
              staticClass: "modal-background",
              on: { click: _vm.deactivate },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _vm.closable
              ? _c("button", {
                  staticClass: "modal-close",
                  attrs: { type: "button" },
                  on: { click: _vm.deactivate },
                })
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }